/**
 * Match payloads often omit crest URLs. Resolve from fixtures / table / home.
 */
export const crestFromSources = (teamId, teamName, sources = {}) => {
  const {
    matchTeam,
    fixtures,
    teams,
    ranking,
    homeSymbol,
    homeTeamId,
    homeTeamName,
  } = sources;

  if (matchTeam?.symbol) return matchTeam.symbol;

  if (
    homeSymbol &&
    ((teamId && String(teamId) === String(homeTeamId)) ||
      (teamName && homeTeamName && teamName === homeTeamName))
  ) {
    return homeSymbol;
  }

  const list = Array.isArray(teams)
    ? teams
    : Array.isArray(ranking)
      ? ranking
      : [];
  const fromList = list.find(
    (team) =>
      (teamId && String(team?._id) === String(teamId)) ||
      (teamName && team?.name === teamName)
  );
  if (fromList?.symbol) return fromList.symbol;

  const days = Array.isArray(fixtures?.matches) ? fixtures.matches : [];
  for (let i = 0; i < days.length; i += 1) {
    const day = days[i];
    const nested = Array.isArray(day?.matches)
      ? day.matches
      : day?.home_team
        ? [day]
        : [];
    for (let j = 0; j < nested.length; j += 1) {
      const match = nested[j];
      const home = match?.home_team;
      const away = match?.away_team;
      if (
        home?.symbol &&
        ((teamId && String(home._id) === String(teamId)) ||
          (teamName && home.name === teamName))
      ) {
        return home.symbol;
      }
      if (
        away?.symbol &&
        ((teamId && String(away._id) === String(teamId)) ||
          (teamName && away.name === teamName))
      ) {
        return away.symbol;
      }
    }
  }
  return null;
};

export const teamInitials = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
};
